module.exports = __webpack_public_path__ + "img/htcm_05.a4959aa3.jpg";